import * as React from "react";
import "./resume.css";

export default function ResumeCard() {
    return (
        <section className="resume">
            <h2>Resume</h2>
            <div className="content">
                <iframe src="./Resume.pdf" width="100%" title="resume" className="pdf"></iframe>
            </div>
        </section>
    );
}